import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { ModelFormComponent } from '../model-form/model-form.component';
import { VehiclemodelService } from "app/rest/vehiclemodel.service";
import { Rest } from "app/rest/rest_client";
import { EntityListComponent } from "app/components/entity-list/entity-list.component";
import { NotificationsService } from "app/services/notifications-service/notifications.service";
import { AuthenticationService } from "app/core/services/authentication/authentication.service";
import { I18nService } from "app/services/i18n/i18n.service";
import { RestExt } from "app/services/rest-client-extension";
import { ExcelService } from "app/services/excel-service/excel.service";
import { TranslateService } from '@ngx-translate/core';
import { VehicleService } from "app/rest/vehicle.service";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
    selector: 'app-model-list',
    templateUrl: './model-list.component.html',
    styleUrls: ['./model-list.component.css'],
    providers: [VehiclemodelService, ConfirmationService, UserTimePipe, ExcelService, VehicleService],
})
export class ModelListComponent
    extends EntityListComponent<Rest.VehicleModel>
    implements OnInit {
    title: string = this.i18n._("VehicleModels");

    @ViewChild(ModelFormComponent, { static: true })
    modelForm: ModelFormComponent;

    disableSave: boolean;

    user: Rest.User;
    EnabledFilter: SelectItem[];
    filterByClient: boolean;



    constructor(
        private modelService: VehiclemodelService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        public translate: TranslateService,
        private route: Router
    ) {
        super(
            modelService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
        this.modelService = modelService;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.modelForm;
        this.hasEntityFilters = false;
        /*Permissions */
        this.user = this.authenticationService.user;
        /** */
    }

    protected beforeLoad(): void {

        if(!this.route.url.includes("control-panel")){
            this.paginationRequest.filters["client"] = [this.user.client.id.toString()];
            this.filterByClient = true;
        }else{
            this.filterByClient = false;
        }


        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }

    excelColumns = {};
    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translate.instant('tableManagement.models.modelsManagement');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
        const brand = (entity: any) => entity.brand?.name ?? ''
        const name = (entity: any) => entity.name ?? ''
        const disabled = (entity: any) => entity.disabled ?? ''
        this.excelColumns = {
            [this.translate.instant('tableManagement.brands.brand')]: { bindField: brand },
            [this.translate.instant('tableManagement.models.model')]: { bindField: name },
            [this.translate.instant('general.disabled')]: { bindField: disabled },
        };
    }

}
